import AddIcon from '@mui/icons-material/Add';
import { LoadingButton } from "@mui/lab";
import { Autocomplete, Box, Button, Chip, FormControl, Grid, Paper, TextField, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MyToastShow from "@/components/Layout/MyToast";
import TablaInformes from "@/components/Tablas/TablaInformes/TablaInformes";
import dayjs from "dayjs";
import es from 'dayjs/locale/es';
import { useRef, useState } from "react";
import { informeApi } from "@/redux/api/informeApi";
import { IUser } from "@/redux/models";
import { useAppSelector } from "@/redux/store";
import { atributos_options } from "@/utils/selectorOptions";

const FiltrarMisInformes = () => {
    const [filterValue, setFilterValue] = useState<any>({})
    const [inputValue, setInputValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [informes, setInformes] = useState<any[]>([])
    const autoC = useRef(null);
    const user = useAppSelector(state => state.userState.user) as IUser;

    const limpiarFiltros = (filtros: any) => {
        let filtroLimpio: any = {}
        for (const key in filtros) {
            if (filtros[key] !== '') {
                filtroLimpio[key] = filtros[key]
            }
        }
        return filtroLimpio
    }

    const [filterValues, setFilterValues] = useState({
        userId: Number(user.id),
        fechaDesde: dayjs().subtract(1, 'month'),
        fechaHasta: dayjs(),
        tipoInforme: '',
        estadoMonetario: '',
        estadoGeneral: '',
        atributoYContenido: [] as { atributo: string, contenido: string }[]
    })

    const filtroValido = () => {
        // if (filterValues.atributoYContenido.length === 0) {
        //     MyToastShow({ message: 'Debe seleccionar al menos un atributo', type: 'error' })
        //     return false
        // }
        return true
    }

    const [obtenerInformesFiltrados] = informeApi.endpoints.obtenerInformesFiltrados.useLazyQuery()

    const filtrar = () => {
        let filtrosString = {
            ...filterValues,
            fechaDesde: filterValues.fechaDesde.format("DD/MM/YYYY"),
            fechaHasta: filterValues.fechaHasta.format("DD/MM/YYYY")
        }

        if (!filtroValido()) return
        setIsLoading(true)
        obtenerInformesFiltrados(limpiarFiltros(filtrosString))
            .unwrap()
            .then((informes) => {
                setInformes(informes)
            })
            .catch((err: any) => {
                MyToastShow({ message: 'No se encontraron informes', type: 'error' })
                setInformes([])
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const FiltrosActivos = () => {
        return (
            <Box sx={{ pt: '1rem' }}>
                {filterValues.atributoYContenido.map((item, index) => (
                    <Chip
                        sx={{ m: '3px' }}
                        key={index}
                        label={item.atributo + ': ' + item.contenido}
                        onDelete={() => {
                            const aux = filterValues.atributoYContenido.filter((_, i) => i !== index)
                            setFilterValues({ ...filterValues, atributoYContenido: aux })
                        }}
                    />
                ))}
            </Box>
        )
    }

    return (
        <>
            <Typography sx={{ textAlign: 'start', fontSize: '1.8rem', fontWeight: 'bold', color: 'primary.main' }}>
                Filtrar Informes
            </Typography>


            <Paper elevation={3} sx={{ mb: 5, p: 3, display: 'flex', alignItems: 'center', borderRadius: '5px' }}>
                <Grid container spacing={2} sx={{ width: '100%', pt: 2, borderRadius: '10px' }}>
                    <Grid item xs={12} md={3} minWidth={'14rem'}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={JSON.stringify(es)}>
                            <DatePicker
                                sx={{ mb: 1 }}
                                slotProps={{ textField: { size: 'small', error: false } }}
                                label="Fecha desde"
                                value={filterValues.fechaDesde || dayjs()}
                                onChange={(newValue: any) => {
                                    setFilterValues({ ...filterValues, fechaDesde: newValue || dayjs() })
                                }}
                                format='DD/MM/YYYY'
                            />
                            <DatePicker
                                slotProps={{ textField: { size: 'small', error: false } }}
                                label="Fecha hasta"
                                value={filterValues.fechaHasta || dayjs()}
                                onChange={(newValue: any) => {
                                    setFilterValues({ ...filterValues, fechaHasta: newValue || dayjs() })
                                }}
                                format='DD/MM/YYYY'
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} md={6} display={'flex'} flexDirection={"column"}>
                        <FormControl >
                            <Autocomplete
                                ref={autoC}
                                disablePortal
                                id="atributos"
                                options={atributos_options}
                                renderInput={(params) => <TextField variant="standard" {...params} label="Campo" />}
                                onChange={(e, value) => {
                                    if (value) {
                                        setFilterValue(value.value)
                                    }
                                }}
                            />
                        </FormControl>
                        <TextField
                            fullWidth
                            variant="standard"
                            label="Valor"
                            sx={{ mt: 2 }}
                            disabled={filterValue === ''}
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue(e.target.value)
                            }}
                        />
                        <Button
                            endIcon={<AddIcon />}
                            size="small"
                            variant="contained"
                            sx={{ mt: 2, minWidth: '120px' }}
                            disabled={filterValue === '' || inputValue === ''}
                            onClick={() => {
                                const miObjeto = {
                                    atributo: filterValue,
                                    contenido: inputValue
                                }
                                if (filterValues.atributoYContenido.find((item) => item.atributo === miObjeto.atributo)) {
                                    MyToastShow({ message: 'Ya se ha agregado este filtro', type: 'error' })
                                    return
                                }
                                setFilterValues({
                                    ...filterValues, atributoYContenido:
                                        [...filterValues.atributoYContenido, miObjeto]
                                })
                            }}
                        >
                            Agregar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={3} minWidth={'14rem'}>
                        <FiltrosActivos />
                    </Grid>
                </Grid>

                <LoadingButton
                    loading={isLoading}
                    variant="contained"
                    onClick={filtrar}
                    sx={{ p: 3, mr: 3 }}
                >
                    Buscar
                </LoadingButton>
            </Paper>

            <TablaInformes
                hideColumns={['usuario', 'ACTION_LIQUIDAR', 'ACTION_EDITAR', 'ACTION_RESTAURAR']}
                informes={informes}
                onPageChange={function (page: number): Promise<void> {
                    throw new Error("Function not implemented.");
                }}
                totalInformes={informes.length}
                rowsPerPage={999999}
            />
        </>
    );
}

export default FiltrarMisInformes;